module.exports = __webpack_public_path__ + "static/media/map.d54829b5.gif";